/* 版本號的唯一來源是 package.json；建置時打包進來。
 * 發版時只改 package.json 的 version，並在 art/content/patches.json 最上面加同版號的更新說明（tests/version.cjs 會檢查） */
import pkg from '../package.json' with { type: 'json' };

export const VERSION: string = 'v' + pkg.version;
